document.addEventListener("DOMContentLoaded", () => {

const cards = document.querySelectorAll(".cr-card");
const btn = document.querySelector(".cr-more");

if(!btn) return;

const mobile = window.innerWidth < 750;
const visible = mobile ? 4 : 8;

cards.forEach((card,index)=>{

if(index >= visible){

card.style.display="none";

}

});

if(cards.length <= visible){

btn.style.display="none";

}

btn.addEventListener("click",()=>{

cards.forEach(card=>{

card.style.display="inline-block";

});

btn.style.display="none";

});

});